import { Atom } from "AppReact";
import styled, { css } from "styled-components";

const template = styled.div`
  ${({ displayState, theme }) => css`
    margin-left: 16px;
    cursor: pointer;
    svg {
      fill: ${theme?.colour?.secondary ?? '#04333b'};
    }
    &:hover {
      svg {
        fill: #FD2020;
      }
    }
  `}
`;

export default Atom({ type: 'button', dataType: 'object', template })
